import { Skeleton } from "@/components/ui/skeleton";

export const DietAddonsSkeleton = () => {
  return (
    <div className="space-y-6">
      <div className="flex gap-4">
        {["a", "b", "c", "d"].map((id) => (
          <Skeleton className="h-8 w-24 rounded-md" key={id} />
        ))}
      </div>
      <div className="flex gap-3 overflow-hidden">
        {["a", "b", "c", "d"].map((id) => (
          <Skeleton className="h-56 w-56 shrink-0 rounded-xl" key={id} />
        ))}
      </div>
    </div>
  );
};
